import { roundToSeconds } from '@mi-front/core';
import moment from 'moment';

/** Input for computing default stream range from URL/init state. */
export interface LoggerRangeConfig {
  readonly cursor?: number | null;
  /** When set and cursor is missing, range is centered on selection.from (same as cursor). */
  readonly selection?: { readonly from: number; readonly to: number } | null;
}

/**
 * Computes a 1-hour [from, to] range for the stream.
 * - If cursor is set: range is one hour centered on cursor.
 * - Else if selection is set: range is one hour centered on selection.from.
 * - Otherwise: range is the last hour up to now.
 */
export function calculateRangeFromConfig(config: LoggerRangeConfig): [number, number] {
  const { cursor, selection } = config;
  const anchorTs = cursor ?? selection?.from;

  let streamFrom: number;

  if (anchorTs != null) {
    streamFrom = roundToSeconds(anchorTs - 30 * 60 * 1000);
  } else {
    streamFrom = roundToSeconds(
      moment().subtract(1, 'hours').subtract(30, 'seconds').startOf('minute').valueOf(),
    );
  }

  const streamTo = moment(streamFrom).add(1, 'hour').valueOf();

  return [streamFrom, streamTo];
}
